import React from "react";
import { Text } from "@commonsku/design-system";

/** Bold, muted label above a run of task rows (e.g. "Recently Completed"). */
const SectionHeading = ({ children }: { children: React.ReactNode }) => (
  <Text fontSize="sm" fontWeight="bold" color="fg.muted" paddingX="2" paddingTop="1.5" paddingBottom="0.5">
    {children}
  </Text>
);

export default SectionHeading;
